import axios from 'axios';

export const api = axios.create({
  baseURL: process.env.REACT_APP_ENDPOINT,
})

export const apiBlob = axios.create({
  baseURL: process.env.REACT_APP_ENDPOINT,
  responseType: "blob"
})

/**
 * Cliente REST do confi-api-app-v4 (`REACT_APP_API_V4`). Envia o JWT da
 * sessão do backoffice em `Authorization: Bearer`, o mesmo token que o
 * Apollo usa no `/gql`. Nenhum segredo entra aqui: tudo que for
 * `REACT_APP_*` é inlinado no bundle público pelo CRA.
 */
export const apiV4 = axios.create({
  baseURL: process.env.REACT_APP_API_V4,
})

apiV4.interceptors.request.use((config) => {
  const token = localStorage.getItem('backoffice@confi');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
})
